import { IIndexData, ShowIds } from "@/common/interface";
import { SET_INDEX } from "../actionTypes";
import { Dispatch } from "react";
import { getIndexData, getPmpData, getShowIds } from "@/common/api";
import { asyncInitAllAppStatus } from "@/store/common/action/appStatus";
import {
  replaceComdataToPage,
  replaceComdataToTab,
  replaceComdataToGamepage,
  pmpindexAdMap,
  sortRandomBanner,
} from "@/utils/com";

export { setAppStatus, setAppProgress } from "@/store/common/action/appStatus";

export const setIndex = (data: IIndexData) => ({
  type: SET_INDEX,
  data,
});

export const asyncGetIndexData = () => {
  return async (dispatch: Dispatch<any>) => {
    let showIds: ShowIds;
    try {
      showIds = await getShowIds();
    } catch (e) {
      showIds = {};
    }

    const {
      comBannerShowIds = [],
      comSpecial1Ids = [],
      comRankIds = [],
      comAdId = [],
      comTabHotIds = [],
      comTabOfficeIds = [],
    } = showIds;

    Promise.all([
      getIndexData(),
      getPmpData([
        ...comBannerShowIds,
        ...comSpecial1Ids,
        ...comRankIds,
        ...comAdId,
        ...comTabHotIds,
        ...comTabOfficeIds,
      ]),
    ])
      .then((res) => {
        const [indexData, pmpData] = res;
        if (indexData.errno === 0) {
          const data: IIndexData = indexData.data;
          const softIds: any = [];
          // 只获取首页soft_id的状态
          const { soft = [], top = [], special1 = [] } = data || {};
          special1.forEach((item: any) => {
            item.soft_id && softIds.push(item.soft_id);
          });
          top.forEach((item: any) => {
            item.soft_id && softIds.push(item.soft_id);
          });
          if (soft[0] && soft[0].data) {
            soft[0].data.forEach((item: any) => {
              item.soft_id && softIds.push(item.soft_id);
            });
          }

          if (pmpData?.adspaces) {
            // 商业化请求成功
            const { banner, ad, special1, top, soft } = data || {};
            // replaceComdataToPage(comBannerShowIds, pmpData, banner);
            indexData.data.banner = sortRandomBanner(
              banner,
              pmpData,
              comBannerShowIds,
            );
            // indexData.data.banner = newBannerData;
            replaceComdataToPage(comSpecial1Ids, pmpData, special1);
            // indexData.data.special1 = newSpecial1;
            replaceComdataToPage(comRankIds, pmpData, top);
            // indexData.data.top = newTop;
            replaceComdataToTab(comTabHotIds, pmpData, soft, "热门推荐");
            replaceComdataToTab(comTabOfficeIds, pmpData, soft, "办公必备");
            // replaceComdataToPage(comAdId, pmpData, ad);
            replaceComdataToGamepage(comAdId, pmpData, ad, pmpindexAdMap);
          }

          // (dispatch(asyncInitAllAppStatus(softIds)) as any).then(() => {
          //   dispatch(asyncInitAllAppStatus(indexData.data.soft_id_list));
          // });

          dispatch(asyncInitAllAppStatus(softIds)) as any;

          return dispatch(setIndex(indexData.data));
        }
        throw new Error(indexData.errmsg || "未知错误");
      })
      .catch((e) => {
        console.log("error is", e);
      });
    // getIndexData().then(res => {
    //   if (res.errno === 0) {
    //     const softIds: any = [];
    //     // 只获取首页soft_id的状态
    //     const { soft = [], top = [], special1 = [] } = res.data || {};
    //     special1.forEach((item: any) => {
    //       item.soft_id && softIds.push(item.soft_id);
    //     });
    //     top.forEach((item: any) => {
    //       item.soft_id && softIds.push(item.soft_id);
    //     });
    //     if (soft[0] && soft[0].data) {
    //       soft[0].data.forEach((item: any) => {
    //         item.soft_id && softIds.push(item.soft_id);
    //       });
    //     }

    //     (dispatch(asyncInitAllAppStatus(softIds)) as any).then(() => {
    //       dispatch(asyncInitAllAppStatus(res.data.soft_id_list));
    //     });
    //     return dispatch(setIndex(res.data));
    //   }
    //   throw new Error(res.errmsg || "未知错误");
    // });
  };
};
